/**
 * @module airport.service
 */
import { DialVerseApi } from '../app/api'
import AppConfig from '../config'

const AirportService = DialVerseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Basic CRUD operations
    getAirports: builder.mutation({
      query: () => ({
        url: AppConfig.getUrl('/airports'),
        method: 'GET',
      }),
    }),
    getAirportById: builder.mutation({
      query: (airportId) => ({
        url: AppConfig.getUrl(`/airports/${airportId}`),
        method: 'GET',
      }),
    }),
    getAirportByCode: builder.mutation({
      query: (code) => ({
        url: AppConfig.getUrl(`/airports/code/${code}`),
        method: 'GET',
      }),
    }),
    createAirport: builder.mutation({
      query: (airport) => ({
        url: AppConfig.getUrl('/airports'),
        method: 'POST',
        body: airport,
      }),
    }),
    updateAirport: builder.mutation({
      query: ({ airportId, ...updates }) => ({
        url: AppConfig.getUrl(`/airports/${airportId}`),
        method: 'PUT',
        body: updates,
      }),
    }),
    deleteAirport: builder.mutation({
      query: (airportId) => ({
        url: AppConfig.getUrl(`/airports/${airportId}`),
        method: 'DELETE',
      }),
    }),

    // Airport-specific operations
    updateAirportStatus: builder.mutation({
      query: ({ airportId, status }) => ({
        url: AppConfig.getUrl(`/airports/${airportId}/status`),
        method: 'PATCH',
        body: { status },
      }),
    }),
    addRunway: builder.mutation({
      query: ({ airportId, runway }) => ({
        url: AppConfig.getUrl(`/airports/${airportId}/runways`),
        method: 'POST',
        body: { runway },
      }),
    }),
    updateRunway: builder.mutation({
      query: ({ airportId, runwayNumber, updates }) => ({
        url: AppConfig.getUrl(`/airports/${airportId}/runways/${runwayNumber}`),
        method: 'PUT',
        body: updates,
      }),
    }),
    removeRunway: builder.mutation({
      query: ({ airportId, runwayNumber }) => ({
        url: AppConfig.getUrl(`/airports/${airportId}/runways/${runwayNumber}`),
        method: 'DELETE',
      }),
    }),

    // Search and filter routes
    searchAirportsByCity: builder.mutation({
      query: (city) => ({
        url: AppConfig.getUrl(`/airports/search/city/${city}`),
        method: 'GET',
      }),
    }),
    searchAirportsByCountry: builder.mutation({
      query: (country) => ({
        url: AppConfig.getUrl(`/airports/search/country/${country}`),
        method: 'GET',
      }),
    }),
    getAirportsByType: builder.mutation({
      query: (type) => ({
        url: AppConfig.getUrl(`/airports/type/${type}`),
        method: 'GET',
      }),
    }),
    getNearbyAirports: builder.mutation({
      query: (params) => ({
        url: AppConfig.getUrl('/airports/nearby'),
        method: 'GET',
        params,
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetAirportsMutation,
  useGetAirportByIdMutation,
  useGetAirportByCodeMutation,
  useCreateAirportMutation,
  useUpdateAirportMutation,
  useDeleteAirportMutation,
  useUpdateAirportStatusMutation,
  useAddRunwayMutation,
  useUpdateRunwayMutation,
  useRemoveRunwayMutation,
  useSearchAirportsByCityMutation,
  useSearchAirportsByCountryMutation,
  useGetAirportsByTypeMutation,
  useGetNearbyAirportsMutation,
} = AirportService
